import React, { useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { setModal } from "../../../../actions/index";

import NoSubscription from '../modals/NoSubscription';

let listener = null;
const timeInterval = 1800000;  //30min
const useNoSubscribeViewer = () => {
  const dispatch = useDispatch();
  const isNoSubscribeViewer = useSelector( state => (
    state.socketConnectPM && state.socketPM && !state.isSubscribed
    && state.enablePM && state.isWatcherPM && state.user
  ) );
  useEffect(() => {
    if (isNoSubscribeViewer) {
      listener = setInterval(() => {
        dispatch(setModal({
          content: <NoSubscription trial={true} />
        }));
      }, timeInterval);
    } else {
      if (listener) { clearInterval(listener)  }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isNoSubscribeViewer, dispatch])

  return null;
};

export default useNoSubscribeViewer;
